import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureFromUrl } from "@/lib/acquisitionSource";

// Scrolls to the top of the window on every route change so pages always
// open at the top instead of inheriting the previous page's scroll position.
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // First-touch acquisition capture on every URL change so `?src=…` links
    // land the tag even if the visitor navigates before signing up.
    captureFromUrl();
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search]);
  return null;
}
